import { useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import Swal from 'sweetalert2';
import UserForm from './UserForm';

import { createUser } from '../../../api/users';
import { PermissionsGate } from '../../PermissionsGate';

const UserAddNewPage = () => {
  const history = useHistory();

  const [form, setForm] = useState({
    username: 'admin',
    employee_no: '',
    last_name: '',
    first_name: '',
    email: '',
    password: '',
    department_id: '',
    job_id: '',
    contact_no: '',
    signature: '',
    signature_file_path: '',
    otp_via: '',
    is_otp: 0,
  });

  const [isChecked, setIsChecked] = useState(false);
  const [emailOtp, setEmailOtp] = useState(false);
  const [smsOtp, setSmsOtp] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileUpload = (e) => {
    setForm({ ...form, [e.target.name]: e.target.files });
  };

  const submitHandler = () => {
    Swal.fire({
      icon: 'info',
      title: 'Are you sure you want to add new user?',
      showConfirmButton: true,
      confirmButtonText: 'Yes',
      showCancelButton: true,
      cancelButtonText: 'No',
      cancelButtonColor: '#dc3545',
    }).then((result) => {
      if (result.isConfirmed) {
        if (checkEmptyFields()) {
          Swal.fire({
            icon: 'warning',
            title: 'Please fill up required fields.',
          });
        } else {
          createUser(form)
            .then((res) => {
              let { code, result } = res.data.response;
              if (code !== '00003') {
                Swal.fire({
                  icon: 'error',
                  text: result,
                  showConfirmButton: true,
                });
              } else {
                Swal.fire({
                  icon: 'success',
                  text: result,
                  showConfirmButton: true,
                });
                history.push('/user-control');
              }
            })
            .catch((err) => {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: err.data.response.result,
              });
            });
        }
      }
    });
  };

  const checkEmptyFields = () => {
    let hasEmptyFields = false;

    let excludedFields = [
      'signature',
      'signature_file_path',
      form.is_otp === 1 ? '' : 'otp_via',
      'is_otp',
    ];
    Object.keys(form).every((field) => {
      if (form[field] === '' && excludedFields.indexOf(field) === -1) {
        hasEmptyFields = true;
        return false;
      }

      return true;
    });

    return hasEmptyFields;
  };

  const checkStatus = async (e) => {
    let status = e.value;
    if (status) {
      setIsChecked(true);
      setEmailOtp(true);
      setForm({ ...form, is_otp: 1, otp_via: 'email' });
    } else {
      setIsChecked(false);
      setEmailOtp(false);
      setSmsOtp(false);
      setForm({ ...form, is_otp: 0, otp_via: '' });
    }
  };

  const onChangeEmail = (e) => {
    let status = e.value;
    setSmsOtp(false);
    if (status) {
      // if (!smsOtp) {
      setEmailOtp(true);
      setForm({ ...form, otp_via: 'email' });
      //}
    } else {
      setEmailOtp(false);
      setForm({ ...form, otp_via: '' });
    }
  };

  const onChangeSms = (e) => {
    let status = e.value;
    setEmailOtp(false);
    if (status) {
      // if (!emailOtp) {
      setSmsOtp(true);
      setForm({ ...form, otp_via: 'sms' });
      // }
    } else {
      setSmsOtp(false);
      setForm({ ...form, otp_via: '' });
    }
  };

  return (
    <Container fluid>
      <PermissionsGate scopes={['add_user']}>
        <Row className="justify-content-md-center">
          <Col lg="6">
            <div className="card mb-3 mt-3">
              <div className="card-header">
                <h3>Add User Page</h3>
              </div>
              <UserForm
                form={form}
                handleChange={handleChange}
                handleFileUpload={handleFileUpload}
                showPassword={true}
              />
              <div className="card-footer">
                <div className="text-right">
                  <Button
                    id="add"
                    variant="success"
                    type="button"
                    onClick={() => {
                      submitHandler();
                    }}
                  >
                    Save
                  </Button>
                  <Link
                    id="cancel"
                    to="/user-control"
                    className="ml-2 btn btn-danger"
                  >
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </PermissionsGate>
    </Container>
  );
};

export default UserAddNewPage;
